import { render, staticRenderFns } from "./PlatformOrder.vue?vue&type=template&id=7395193f&"
import script from "./PlatformOrder.vue?vue&type=script&lang=js&"
export * from "./PlatformOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports